<template>
	<div v-editable="blok">
		<div
			v-show="shouldDisplay"
			class="absolute z-[2] flex justify-center items-center text-white md:text-[13px] text-[11px]"
			:class="`${blok.position} ${blok.size} ${blok.color} ${blok.shape}`"
		>
			{{ blok.text }}
		</div>
	</div>
</template>

<script setup lang="ts">
import type { PromoBlock } from "~/types/storyblok/storyblok";

interface Props {
	blok: PromoBlock;
}

const { blok } = defineProps<Props>();

const { shouldDisplay } = useDisplayBlock(blok.start_date, blok.end_date);
</script>
